import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/fr';

@Component({
  selector: 'ags-next-task',
  templateUrl: './next-task.component.html',
  styleUrls: ['./next-task.component.scss']
})
export class NextTaskComponent implements OnInit {
  @Input() dates: any[];

  constructor() {}

  ngOnInit() {}

  formatDateTask(date) {
    const dayMoment = moment(date).format('dddd');
    const dateMoment = moment(date).format('LL');
    return `${dayMoment} ${dateMoment}`;
  }
}
